import React from 'react';
import { Col, Form, Row, Button } from 'react-bootstrap';
import { useAdvanceTableContext } from 'providers/AdvanceTableProvider';
import AdvanceTableSearchBox from 'components/common/advance-table/AdvanceTableSearchBox';
import PropTypes from 'prop-types';
import IconButton from 'components/common/IconButton';
import Flex from 'components/common/Flex';

// eslint-disable-next-line react/prop-types
const DocumentTableHeader = ({ document, uploadDoc, setUploadDoc }) => {
  const { getSelectedRowModel } = useAdvanceTableContext();

  return (
    <>
      {uploadDoc ? (
        <Row className="flex-between-center">
          <Col className="pe-0">
            <Row className="g-2">
              <Col>
                <h5 className="mb-0">Upload Document</h5>
              </Col>
            </Row>
          </Col>
        </Row>
      ) : (
        <Row className="flex-between-center">
          <Col className="pe-0">
            <Row className="g-2">
              <Col>
                <h5 className="mb-0">Document List ({document?.length})</h5>
              </Col>
            </Row>
          </Col>
          <Col xs={8} sm={6} lg={4} className="ms-auto text-end ps-0">
            {getSelectedRowModel().rows.length > 0 ? (
              <div className="d-flex">
                <Form.Select size="sm" aria-label="Bulk actions">
                  <option>Bulk Actions</option>
                  <option value="refund">Refund</option>
                  <option value="delete">Delete</option>
                  <option value="archive">Archive</option>
                </Form.Select>
                <Button
                  type="button"
                  variant="falcon-default"
                  size="sm"
                  className="ms-2"
                >
                  Apply
                </Button>
              </div>
            ) : (
              <div id="orders-actions">
                <Flex>
                  <Col xs="auto" className="d-flex order-md-0">
                    <IconButton
                      variant="primary"
                      iconClassName="me-2"
                      icon="plus"
                      size="sm"
                      className="mx-2"
                      onClick={() => {
                        setUploadDoc(!uploadDoc);
                      }}
                    >
                      Upload Document
                    </IconButton>
                  </Col>
                  <AdvanceTableSearchBox />
                </Flex>
              </div>
            )}
          </Col>
        </Row>
      )}
    </>
  );
};

DocumentTableHeader.propTypes = {
  document: PropTypes.any,
  uploadDoc: PropTypes.any,
  setUploadDoc: PropTypes.any
};

export default DocumentTableHeader;
